import { render, staticRenderFns } from "./SaleType.vue?vue&type=template&id=6229f4be"
import script from "./SaleType.vue?vue&type=script&lang=ts"
export * from "./SaleType.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports